import React from "react";
import { FaInstagram, FaFacebookF, FaLinkedinIn, FaYoutube, FaTwitter, FaGoogle } from "react-icons/fa";

import company from "../data/company";

const ICONS = [
  { Icon: FaInstagram, href: company.social.instagram, label: "Instagram" },
  { Icon: FaFacebookF, href: company.social.facebook, label: "Facebook" },
  { Icon: FaLinkedinIn, href: company.social.linkedin, label: "LinkedIn" },
  { Icon: FaYoutube, href: company.social.youtube, label: "YouTube" },
  { Icon: FaTwitter, href: company.social.twitter, label: "Twitter" },
  { Icon: FaGoogle, href: company.social.google, label: "Google" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="w-full bg-cream-200/40 text-maroon-700 py-6" id="site-footer">
      <div className="max-w-6xl mx-auto px-4 flex flex-col items-center gap-4">
        <div className="flex flex-wrap items-center justify-center gap-3">
          {ICONS.map(({ Icon, href, label }) => (
            <a
              key={label}
              href={href}
              aria-label={label}
              className="flex items-center justify-center h-8 w-8 rounded-full border border-maroon-700/30 text-maroon-700 hover:bg-maroon-700 hover:text-cream-100 hover:border-maroon-700 transition-colors"
            >
              <Icon className="h-3.5 w-3.5" />
            </a>
          ))}
        </div>
        <p className="font-body text-xs text-center">© {year} Sutramay Industries. All rights reserved.</p>
      </div>
    </footer>
  );
}
